<template>
    <div>
        <h2>Zusammenfassung</h2>
        <ion-list lines="none" class="c-summary-list">
            <ion-item-group>
                <ion-item-divider mode="ios">
                    <ion-label>Was ist passiert?</ion-label>
                </ion-item-divider>
                <ion-item>
                    <ion-label>{{ formData.schadenArt }}</ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('schadenArt')"
                        v-if="
                            formData.mode !== 'haushalt' &&
                            formData.mode !== 'recht' &&
                            formData.mode !== 'sach' &&
                            formData.mode !== 'unfall'
                        "
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.hasUnfallbericht">
                    <ion-label>
                        Unfallbericht:
                        {{ formData.hasUnfallbericht }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('unfallbericht')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <template v-if="formData.mode === 'krankenhaus'">
                    <ion-item-divider mode="ios">
                        <ion-label>Aufenthalt im Krankenhaus</ion-label>
                    </ion-item-divider>
                    <ion-item>
                        <ion-label>
                            Von: {{ formatDate(formData.von) }}<br />
                            Bis: {{ formatDate(formData.bis) }}
                        </ion-label>
                        <ion-button
                            slot="end"
                            fill="clear"
                            @click="changeStep('vonBis')"
                        >
                            <ion-icon
                                name="md-create"
                                slot="icon-only"
                            ></ion-icon>
                        </ion-button>
                    </ion-item>
                    <ion-item>
                        <ion-label>
                            Name: {{ formData.krankenhaus }}
                        </ion-label>
                        <ion-button
                            slot="end"
                            fill="clear"
                            @click="changeStep('krankenhaus')"
                        >
                            <ion-icon
                                name="md-create"
                                slot="icon-only"
                            ></ion-icon>
                        </ion-button>
                    </ion-item>
                </template>
                <ion-item-divider
                    mode="ios"
                    v-if="formData.unfallOrt || formData.unfallBeschreibung"
                >
                    <ion-label>Unfallort und -hergang</ion-label>
                </ion-item-divider>
                <ion-item v-if="formData.unfallOrt">
                    <ion-label>
                        {{ formData.unfallStrasse }} {{ formData.unfallHausnr
                        }}<br />
                        {{ formData.unfallPlz }} {{ formData.unfallOrt }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('unfallOrt')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.unfallBeschreibung">
                    <ion-label>
                        {{ formData.unfallBeschreibung }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('unfallBeschreibung')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item-divider
                    mode="ios"
                    v-if="
                        formData.entstandenerschaden ||
                        formData.schadensfotos !== null ||
                        formData.hasSchadenBeschreibungFremd === 'Ja'
                    "
                >
                    <ion-label>Was wurde beschädigt?</ion-label>
                </ion-item-divider>
                <ion-item v-if="formData.entstandenerschaden">
                    <ion-label>
                        {{ formData.entstandenerschaden
                        }}<span v-if="formData.schadenBeschreibung"
                            >: {{ formData.schadenBeschreibung }}</span
                        >
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('entstandenerschaden')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.schadensfotos !== null">
                    <ion-label>
                        Unfallfotos:
                        {{ unfallfotosCount }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('unfallfotos')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.hasSchadenBeschreibungFremd === 'Ja'">
                    <ion-label>
                        Gegenstände:
                        {{ formData.schadenBeschreibungFremd }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('schadenBeschreibungFremd')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item-divider
                    mode="ios"
                    v-if="
                        formData.hasSchadenhoehe === 'Ja' ||
                        formData.hasSchadenhoeheFremd === 'Ja'
                    "
                >
                    <ion-label>Geschätzte Schadenhöhe</ion-label>
                </ion-item-divider>
                <ion-item v-if="formData.hasSchadenhoehe === 'Ja'">
                    <ion-label
                        >Gesamt: {{ formData.schadenHoehe
                        }}<br />Kostenvoranschlag:
                        {{
                            formData.kostenvoranschlag.length ? "Ja" : "Nein"
                        }}</ion-label
                    >
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('schadenHoehe')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.hasSchadenhoeheFremd === 'Ja'">
                    <ion-label
                        >Gegenstände: {{ formData.schadenHoeheFremd
                        }}<br />Kostenvoranschlag:
                        {{
                            formData.kostenvoranschlagFremd.length
                                ? "Ja"
                                : "Nein"
                        }}</ion-label
                    >
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('schadenHoeheFremd')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item-divider
                    mode="ios"
                    v-if="formData.beteiligte || formData.beteiligteFahrzeuge"
                >
                    <ion-label>Beteiligte</ion-label>
                </ion-item-divider>
                <ion-item v-if="formData.beteiligte">
                    <ion-label>
                        Personen<span v-if="formData.mode === 'haushalt'"
                            >/Sachen</span
                        >:
                        {{ formData.beteiligte.length }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('beteiligte')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.beteiligteFahrzeuge">
                    <ion-label>
                        Fahrzeuge: {{ formData.beteiligteFahrzeuge.length }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('beteiligteFahrzeuge')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item-divider
                    mode="ios"
                    v-if="formData.hasPolizeidokumente || formData.modrive"
                >
                    <ion-label>Zusätze</ion-label>
                </ion-item-divider>
                <ion-item v-if="formData.hasPolizeidokumente">
                    <ion-label>
                        Polizeiliche Aufnahme:
                        {{ formData.hasPolizeidokumente }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('polizei')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.sportartMitEinkommen">
                    <ion-label>
                        Sportart mit Einkommen:
                        {{ formData.sportartMitEinkommen }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('sportartMitEinkommen')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.alkoholDrogen">
                    <ion-label>
                        Einwirkung von Alkohol oder Drogen:
                        {{ formData.alkoholDrogen }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('alkoholDrogen')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.sportpaketRahmen">
                    <ion-label>
                        Im Rahmen des versicherten Sportpaketes:
                        {{ formData.sportpaketRahmen }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('sportpaketRahmen')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
                <ion-item v-if="formData.modrive">
                    <ion-label>
                        MO'Drive Reparatur-Service: {{ formData.modrive }}
                    </ion-label>
                    <ion-button
                        slot="end"
                        fill="clear"
                        @click="changeStep('modrive')"
                    >
                        <ion-icon name="md-create" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item>
            </ion-item-group>
        </ion-list>
    </div>
</template>

<script>
import { DateFormatter } from "@/utils/date";

export default {
    props: {
        formData: {
            required: true,
            type: Object,
        },
        stepMap: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {};
    },
    methods: {
        changeStep(stepMapValue) {
            this.$emit("change-step", this.stepMap[stepMapValue]);
        },
        formatDate(dateString) {
            return DateFormatter.formatDate(new Date(dateString), "DD.MM.YYYY");
        },
    },
    computed: {
        unfallfotosCount() {
            let result = 0;
            if (this.formData.unfallfotosSonstige) {
                result = result + this.formData.unfallfotosSonstige.length;
            }
            if (this.formData.unfallfotosEigene) {
                result = result + this.formData.unfallfotosEigene.length;
            }
            if (this.formData.unfallfotosFremd) {
                result = result + this.formData.unfallfotosFremd.length;
            }
            if (this.formData.schadensfotos) {
                result = result + this.formData.schadensfotos.length;
            }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-summary-list {
    ion-label {
        white-space: normal;
    }
}
</style>
